<template>
  <div>
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-actions class="text-left">
        <v-row>
          <v-col cols="12" class="text-left">
            <v-icon class="back-link-icon" x-large @click="$router.push('/students/index')">mdi-arrow-left</v-icon>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-title>تنظیمات هنرجویان</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="2" lg="2">
            <v-select label=" وضعیت هنرجویان بلافاصله پس از ثبت نام"
                      :items="[{text:'فعال شوند',value:'active'},{text:'در انتظار تایید ادمین باشند',value:'waiting'}]"
                      color="black" v-model="settings.status">
            </v-select>
          </v-col>
          <v-col cols="12" sm="12" md="4" lg="4">
            <v-text-field color="black" label="رمز عبور تمام هنرجویان در انتظار تایید به مقدار زیر تغییر یابد"
                          v-model="settings.passwords">
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="3" lg="3">
            <v-text-field color="black" label="به تعداد عدد زیر از اعلان های هنرجویان پاک شود"
                          v-model="settings.delete_notification_count">
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="3" lg="3">
            <v-text-field color="black" label="هنرجویانی که ... ماه فعال نبوده اند اتوماتیک از سایت حذف شوند"
                          hint="برای حذف نشدن هنرجویان عدد صفر وارد شود"
                          v-model="settings.delete_user_count">
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="3" lg="3">
            <v-switch color="black" label="وضعیت اعلان خوش آمد گویی"
                      v-model="settings.welcome_notification_status" :true-value="true" :false-value="false"></v-switch>
          </v-col>
          <v-col cols="12">
            پیام خوش آمد گویی
            <ckeditor color="black" v-model="settings.welcome_notification_message"></ckeditor>
          </v-col>
          <v-col cols="12">
            <v-btn block color="success" @click="updateSettings">اعمال تغییرات</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "StudentSetting",
  data() {
    return {
      settings: {
        status: null,
        passwords: null,
        delete_notification_count: 0,
        delete_user_count: null,
        welcome_notification_status: null,
        welcome_notification_message: null
      }
    }
  },
  mounted() {
    this.getSettings()
  },
  methods: {
    getSettings() {
      window.axios.get('setting/students/index').then((res) => {
        this.settings = res.data.data
      })
    },
    updateSettings() {
      window.axios.post('setting/students/update', this.settings).then(() => {
        this.openSnackbar('تنظیمات هنرجویان با موفقیت ویرایش شد.', 'success')
        this.getSettings()
      }).catch((err) => {
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else if (err.response.status === 400) {
          this.openSnackbar(err.response.data.message, '#F1416C')
        }
      })
    }
  }
}
</script>

<style scoped>

</style>